export const Constants = {

    //HTTP METHODS
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',

    // Page Names
    HOME_PAGE: 'main',
    HOME_PAGE_BANNER: 'home',
    CASINO_PAGE: 'casino',
    LIVE_CASINO_PAGE: 'livecasino',
    TOURNAMENTS: 'game-tournaments',
    MY_PROFILE: 'myProfile',
    REGISTRATION: 'registration',
    LOGIN: 'login',
    JOIN: 'join',
    SPORT_PAGE: 'sport',
    RULES_PAGE: 'rules',
    FAST_GAMES_PAGE: 'fast-games',
    TV_GAMES_PAGE: 'tv-games',
    ESPORT_PAGE: 'esport',
    GAME_INFO:'info'
};

export default Constants;